import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4fc1b6f7&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=4fc1b6f7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc1b6f7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fc1b6f7')) {
      api.createRecord('4fc1b6f7', component.options)
    } else {
      api.reload('4fc1b6f7', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4fc1b6f7&scoped=true&", function () {
      api.rerender('4fc1b6f7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/charts/vacations/components/table/index.vue"
export default component.exports